import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { formatDateToDDMMYYYY } from "../../../../Utility/constants";
import "./TeacherDetailsList.css";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../../../Utility/constants";
import AdminHeader from "../../../common/AdminHeader";
import * as XLSX from "xlsx";

const StaffRegistrationReport = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const url = `${baseUrl}/api/Teachers/StaffRegReport`;

      const response = await axios.get(url);

      if (
        response &&
        response.data &&
        response.data.length > 0
      ) {
        setData(response.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setData([]);
    }
  };

  // ==========================================
  // GET CLASS SUBJECT DETAILS
  // ==========================================
  const getClassSubjectDetails = (item) => {
    if (
      !item.classSubjectDetails ||
      item.classSubjectDetails.length === 0
    ) {
      return [];
    }

    return item.classSubjectDetails;
  };

  // ==========================================
  // CLASS
  // ==========================================
  const getClasses = (item) => {
    const details = getClassSubjectDetails(item);

    return details
      .map((x) => x.class)
      .filter(Boolean)
      .filter((value, index, self) => self.indexOf(value) === index)
      .join(", ");
  };

  // ==========================================
  // SECTION
  // ==========================================
  const getSections = (item) => {
    const details = getClassSubjectDetails(item);

    return details
      .map((x) => x.section)
      .filter(Boolean)
      .filter((value, index, self) => self.indexOf(value) === index)
      .join(", ");
  };

  // ==========================================
  // STREAM
  // ==========================================
  const getStreams = (item) => {
    const details = getClassSubjectDetails(item);

    return details
      .map((x) => x.stream)
      .filter(Boolean)
      .filter((value, index, self) => self.indexOf(value) === index)
      .join(", ");
  };

  // ==========================================
  // SUBJECT
  // ==========================================
  const getSubjects = (item) => {
    const details = getClassSubjectDetails(item);

    return details
      .map((x) => x.subject)
      .filter(Boolean)
      .filter((value, index, self) => self.indexOf(value) === index)
      .join(", ");
  };

  // ==========================================
  // CLASS TEACHER
  // ==========================================
  const isClassTeacher = (item) => {
    return (
      item.classSubjectDetails &&
      item.classSubjectDetails.some(
        (x) => x.isClassTeacher === 1
      )
    );
  };

  // ==========================================
  // ROLE DISPLAY
  // ==========================================
  const getRole = (item) => {
    return isClassTeacher(item)
      ? "Class Teacher"
      : item.role || "N/A";
  };

  // ==========================================
  // CLASS SUBJECT DETAILS FOR DISPLAY
  // ==========================================
  const getClassSubjectDisplay = (item) => {
    const details = getClassSubjectDetails(item);

    if (details.length === 0) {
      return [];
    }

    return details.map((x) => {
      let value = `${x.class || "N/A"} - ${x.section || "N/A"}`;

      if (x.stream) {
        value += ` - ${x.stream}`;
      }

      if (x.subject) {
        value += ` - ${x.subject}`;
      }

      if (x.isClassTeacher === 1) {
        value += " (Class Teacher)";
      }

      return value;
    });
  };

  // ==========================================
  // EXPORT EXCEL
  // ==========================================
  const exportToExcel = () => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    const exportData = data.map((item, index) => {

      const details = getClassSubjectDetails(item);

      const classDetails = details
        .map((x) => x.class)
        .filter((x) => x !== null && x !== undefined && x !== "")
        .join(", ");

      const sectionDetails = details
        .map((x) => x.section)
        .filter((x) => x !== null && x !== undefined && x !== "")
        .join(", ");

      const streamDetails = details
        .map((x) => x.stream)
        .filter((x) => x !== null && x !== undefined && x !== "")
        .join(", ");

      const subjectDetails = details
        .map((x) => x.subject)
        .filter((x) => x !== null && x !== undefined && x !== "")
        .join(", ");

      const classTeacherDetails = details
        .filter((x) => x.isClassTeacher === 1)
        .map((x) => {
          let value = `${x.class || ""}`;

          if (x.section) {
            value += ` - ${x.section}`;
          }

          if (x.stream) {
            value += ` - ${x.stream}`;
          }

          return value;
        })
        .join("\n");

      return {
        "Sr. No.": index + 1,
        "Full Name": item.fullName || "",
        "Gender": item.gender || "",
        "Date of Birth": item.dateOfBirth
          ? formatDateToDDMMYYYY(item.dateOfBirth)
          : "",
        "Address": item.address || "",
        "Phone": item.phone || "",
        "Email": item.email || "",
        "Joining Date": item.joiningDate
          ? formatDateToDDMMYYYY(item.joiningDate)
          : "",
        "Role": item.role || "",
        "Teacher Type": item.teacherType || "",
        "Salary": item.salary ?? "",
        "Aadhaar No": item.aadhaarCardNumber || "",
        "Grant Types": item.grantTypes || "",
        "Retirement Date": item.retirementDate
          ? formatDateToDDMMYYYY(item.retirementDate)
          : "",
        "Teacher Category ID": item.teacherCategoryId ?? "",
        "Educational Qualification":
          item.educationalQualification || "",
        "Pay Scale Salary": item.payScaleSalary || "",
        "Chart Type": item.chartType || "",
        "Post Type": item.postType || "",
        "Designation": item.designation || "",
        "Pay Grade Sanctioned Date":
          item.payGradeSanctionedDate
            ? formatDateToDDMMYYYY(
              item.payGradeSanctionedDate
            )
            : "",
        "Selection Category Approved Date":
          item.selectionCategoryApprovedDate
            ? formatDateToDDMMYYYY(
              item.selectionCategoryApprovedDate
            )
            : "",
        "Vaiyaktik Manyata":
          item.vaiyaktikManyata || "",
        "Vaiyaktik Manyata Date":
          item.vaiyaktikManyataDate
            ? formatDateToDDMMYYYY(
              item.vaiyaktikManyataDate
            )
            : "",
        "Vaiyaktik Manyata Outward Number":
          item.vaiyaktikManyataOutwardNumber || "",

        "Class": classDetails,
        "Section": sectionDetails,
        "Stream": streamDetails,
        "Subject": subjectDetails,
        //"Class Teacher": classTeacherDetails || "No"
      };
    });

    const worksheet =
      XLSX.utils.json_to_sheet(exportData);

    // ==========================================
    // COLUMN WIDTHS
    // ==========================================

    worksheet["!cols"] = [
      { wch: 8 },   // Sr No
      { wch: 25 },  // Full Name
      { wch: 12 },  // Gender
      { wch: 15 },  // DOB
      { wch: 40 },  // Address
      { wch: 15 },  // Phone
      { wch: 30 },  // Email
      { wch: 15 },  // Joining Date
      { wch: 15 },  // Role
      { wch: 18 },  // Teacher Type
      { wch: 12 },  // Salary
      { wch: 18 },  // Aadhaar
      { wch: 20 },  // Grant
      { wch: 18 },  // Retirement
      { wch: 18 },  // Category
      { wch: 30 },  // Qualification
      { wch: 20 },  // Pay Scale
      { wch: 15 },  // Chart
      { wch: 15 },  // Post
      { wch: 20 },  // Designation
      { wch: 22 },  // Pay Grade Date
      { wch: 28 },  // Selection Date
      { wch: 20 },  // Vaiyaktik Manyata
      { wch: 22 },  // Manyata Date
      { wch: 30 },  // Outward Number
      { wch: 15 },  // Class
      { wch: 15 },  // Section
      { wch: 20 },  // Stream
      { wch: 25 },  // Subject
      //{ wch: 25 }   // Class Teacher
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Staff Registration"
    );

    XLSX.writeFile(
      workbook,
      "Staff_Registration_Report.xlsx"
    );
  };

  return (
    <>
      <AdminHeader />

      <div className="mt-5 mb-5 ms-5 me-5">

        {/* ==========================================
            HEADER
        ========================================== */}

        <div className="d-flex align-items-center justify-content-center gap-3 mb-4 flex-nowrap">

          <h2 className="mb-0 me-3 text-nowrap">
            Staff Registration Report
          </h2>

          <button
            className="btn btn-primary text-nowrap"
            onClick={exportToExcel}
            disabled={data.length === 0}
          >
            Export Excel
          </button>

        </div>

        {/* ==========================================
            TABLE
        ========================================== */}

        <div
          style={{
            width: "100%",
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "70vh",
            border: "1px solid #dee2e6"
          }}
        >
          <Table
            striped
            bordered
            hover
            className="mb-0"
            style={{
              minWidth: "2200px",
              tableLayout: "fixed"
            }}
          >

            <thead
              className="table-dark"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2
              }}
            >
              <tr>

                <th style={{ width: "60px" }}>
                  #
                </th>

                <th style={{ width: "220px" }}>
                  Full Name
                </th>

                <th style={{ width: "100px" }}>
                  Gender
                </th>

                <th style={{ width: "130px" }}>
                  Date of Birth
                </th>

                <th style={{ width: "280px" }}>
                  Address
                </th>

                <th style={{ width: "140px" }}>
                  Phone
                </th>

                <th style={{ width: "250px" }}>
                  Email
                </th>

                <th style={{ width: "130px" }}>
                  Joining Date
                </th>

                <th style={{ width: "140px" }}>
                  Role
                </th>

                <th style={{ width: "150px" }}>
                  Teacher Type
                </th>

                <th style={{ width: "120px" }}>
                  Salary
                </th>

                <th style={{ width: "160px" }}>
                  Aadhaar No
                </th>

                <th style={{ width: "150px" }}>
                  Retirement Date
                </th>

                <th style={{ width: "180px" }}>
                  Qualification
                </th>

                <th style={{ width: "160px" }}>
                  Designation
                </th>

                <th style={{ width: "150px" }}>
                  Class
                </th>

                <th style={{ width: "120px" }}>
                  Section
                </th>

                <th style={{ width: "160px" }}>
                  Stream
                </th>

                <th style={{ width: "220px" }}>
                  Subject
                </th>

                {/* <th style={{ width: "250px" }}>
                  Class Teacher
                </th> */}

              </tr>
            </thead>

            <tbody>

              {data.length === 0 ? (

                <tr>
                  <td
                    colSpan="21"
                    className="text-center"
                  >
                    No data available
                  </td>
                </tr>

              ) : (

                data.map((item, index) => (

                  <tr key={item.id || index}>

                    <td>
                      {index + 1}
                    </td>

                    <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere"
                      }}
                    >
                      {item.fullName || "N/A"}
                    </td>

                    <td>
                      {item.gender || "N/A"}
                    </td>

                    <td>
                      {item.dateOfBirth
                        ? formatDateToDDMMYYYY(
                          item.dateOfBirth
                        )
                        : "N/A"}
                    </td>

                    <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere"
                      }}
                    >
                      {item.address || "N/A"}
                    </td>

                    <td>
                      {item.phone || "N/A"}
                    </td>

                    <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere"
                      }}
                    >
                      {item.email || "N/A"}
                    </td>

                    <td>
                      {item.joiningDate
                        ? formatDateToDDMMYYYY(
                          item.joiningDate
                        )
                        : "N/A"}
                    </td>

                    <td>
                      {getRole(item)}
                    </td>

                    <td>
                      {item.teacherType || "N/A"}
                    </td>

                    <td>
                      {item.salary ?? "N/A"}
                    </td>

                    <td>
                      {item.aadhaarCardNumber || "N/A"}
                    </td>

                    <td>
                      {item.retirementDate
                        ? formatDateToDDMMYYYY(
                          item.retirementDate
                        )
                        : "N/A"}
                    </td>

                    <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word"
                      }}
                    >
                      {item.educationalQualification ||
                        "N/A"}
                    </td>

                    <td>
                      {item.designation || "N/A"}
                    </td>

                    <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word"
                      }}
                    >
                      {getClasses(item) || "N/A"}
                    </td>

                    <td>
                      {getSections(item) || "N/A"}
                    </td>

                    <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word"
                      }}
                    >
                      {getStreams(item) || "N/A"}
                    </td>

                    <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word"
                      }}
                    >
                      {getSubjects(item) || "N/A"}
                    </td>

                    {/* <td
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word"
                      }}
                    >
                      {getClassSubjectDisplay(item).map(
                        (detail, i) => (
                          <div key={i}>
                            {detail}
                          </div>
                        )
                      )}
                    </td> */}

                  </tr>

                ))

              )}

            </tbody>

          </Table>
        </div>

      </div>
    </>
  );
};

export default StaffRegistrationReport;